import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page) {
  return request({
    url:    `/client-payment/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

const ClientPaymentService = {
  get
}

export default ClientPaymentService;
